export const normes = {
  normes: 'Normen',
  normesMinimal: 'Minimale normen',
};
